const candidate = {
    id: null,
    pin: null,
    demo: false,
    fullName: '',
};
const activeEvent = {id: null, lang: null};
const currentTesting = {id: null, questionSettings: null, testTypeId: null};
const currentEvent = {id: null};


const candidateModule = {
        namespaced: true,
        state: {
            candidate: candidate,
            activeTesting: false,
            systemTime: null,
            testingEvents: [],
            activeEvent: activeEvent,
            currentTesting: currentTesting,
            currentEvent: currentEvent,
            showTimer: false,
            answers: [],
            currentQuestionNo: 0,
            questionCount: 0,
            currentNpa: '',
        },
        getters: {
            //candidate
            getCandidate: state => state.candidate,
            getCandidateId: state => state.candidate.id,
            getCandidatePin: state => state.candidate.pin,
            getDemo: state => state.candidate.demo,

            getSystemTime: state => state.systemTime,

            //active test
            hasActiveTesting: state => state.activeTesting,

            //candidate events
            getEvents: state => state.testingEvents,

            //active event
            getActiveEvent: state => state.activeEvent,
            getActiveEventId: state => state.activeEvent.id,
            getActiveEventLang: state => state.activeEvent.lang,

            //application
            getCurrentApp: (state, getters) => {
                return getters.getCurrentEvent.application;
            },

            //finished event
            getCandidateEvent: (state, getters) => {
                if (getters.getCurrentEvent.candidateEvent)
                    return getters.getCurrentEvent.candidateEvent;

                return false;
            },

            //current test type
            getCurrentTesting: state => state.currentTesting,
            getCurrentNpa: state => state.currentNpa,
            getCurrentTestingId: state => state.currentTesting.id,

            //timer
            isTimerEnabled: state => state.showTimer,

            //current event
            getCurrentEvent: state => state.currentEvent,
            getCurrentEventId: state => state.currentEvent.id,

            //answers saved
            getAnswers: state => state.answers,
            answerCount: state => state.answers.length,

            //questions
            getQuestionCount: state => state.questionCount,
            getCurrentQuestionNo: state => state.currentQuestionNo,


        },
        mutations: {
            SET_CANDIDATE: (state, value) => {
                state.candidate = value;
            },
            SET_ACTIVE_TESTING: (state, value) => {
                state.activeTesting = value;
            },
            SET_TESTING_EVENTS: (state, value) => {
                state.testingEvents = value;
            },
            SET_ACTIVE_EVENT: (state, value) => {
                state.activeEvent = value;
            },
            SET_CURRENT_TESTING: (state, value) => {
                state.currentTesting = value;
            },
            SET_SHOW_TIMER: (state, value) => {
                state.showTimer = value;
            },
            ADD_ANSWER: (state, value) => {
                state.answers.push(value);
            },
            SET_CURRENT_NPA: (state, value) => {
                state.currentNpa = value;
            },
            SET_ANSWEREDS: (state, value) => {
                state.answers = value;
            },
            SET_QUESTION_COUNT: (state, value) => {
                state.questionCount = value;
            },
            SET_CURRENT_QUESTION_NO: (state, value) => {
                state.currentQuestionNo = value;
            },
            SET_CURRENT_EVENT: (state, value) => {
                state.currentEvent = value;
            },
            SET_SYSTEM_TIME: (state, value) => {
                state.systemTime = value;
            }
        },
        actions: {

            //current testing event
            setCurrentEvent: ({commit}, value) => commit('SET_CURRENT_EVENT', value),
            resetCurrentEvent: ({commit}) => commit('SET_CURRENT_EVENT', currentEvent),

            setSystemTime: ({commit}, value) => commit('SET_SYSTEM_TIME', value),

            //set candidate info
            setCandidate: ({commit}, value) => {
                if (value)
                    commit('SET_CANDIDATE', value);
                else
                    commit('SET_CANDIDATE', candidate);
            },
            resetCandidate: ({commit}) => commit('SET_CANDIDATE', candidate),


            //candidate's events
            setTestingEvents: ({commit}, value) => commit('SET_TESTING_EVENTS', value),

            //whether candidate has active testing
            setActiveTesting: ({commit}, value) => commit('SET_ACTIVE_TESTING', value),

            //event started by candidate
            setActiveEvent: ({commit}, value) => commit('SET_ACTIVE_EVENT', value),
            resetActiveEvent: ({commit}) => commit('SET_ACTIVE_EVENT', activeEvent),

            //current test type
            setCurrentTesting: ({commit}, value) => commit('SET_CURRENT_TESTING', value),
            setCurrentNPA: ({commit}, value) => commit('SET_CURRENT_NPA', value),
            resetCurrentTesting: ({commit}) => commit('SET_CURRENT_TESTING', currentTesting),

            //timer
            enableTimer: ({commit}) => commit('SET_SHOW_TIMER', true),
            disableTimer: ({commit}) => commit('SET_SHOW_TIMER', false),

            //save answers
            setAnswereds: ({commit}, value) => commit('SET_ANSWEREDS', value),

            //current question
            setCurrentQuestionNo: ({commit}, value) => commit('SET_CURRENT_QUESTION_NO', value),

            //questions' number
            setQuestionCount: ({commit}, value) => commit('SET_QUESTION_COUNT', value),

        }
    }
;

export default candidateModule;
